import { Link } from "react-router-dom";
import { ChevronRight, ExternalLink, Refrigerator } from "lucide-react";

/**
 * Prominent Smart Fridge call-to-action banner.
 *
 * Default: links to the internal interactive fridge layout (`/loc/:slug/fridge`).
 * If `externalUrl` is provided (legacy `smart_fridge_url` on Location), use that
 * external URL instead and open it in a new tab.
 */
export default function SmartFridgeBanner({ slug, externalUrl }) {
  const isExternal = !!externalUrl;
  const commonProps = {
    className:
      "group flex items-center justify-between gap-3 w-full bg-gradient-to-r from-amber-50 to-amber-100 hover:from-amber-100 hover:to-amber-200 border-2 border-amber-300 rounded-xl px-4 py-3 sm:py-4 shadow-sm hover:shadow-md transition-all",
    "data-testid": "smart-fridge-link",
  };

  const inner = (
    <>
      <div className="flex items-center gap-3 min-w-0">
        <div className="bg-amber-500 rounded-full p-2 sm:p-2.5 flex-shrink-0 group-hover:scale-110 transition-transform">
          <Refrigerator className="w-5 h-5 sm:w-6 sm:h-6 text-white" strokeWidth={2.5} />
        </div>
        <div className="min-w-0">
          <h3 className="text-sm sm:text-base font-bold text-amber-900 leading-tight">
            View Fridge Layout
          </h3>
          <p className="text-xs sm:text-sm text-amber-700 leading-tight">
            See where to find each item on the shelf
          </p>
        </div>
      </div>
      {isExternal ? (
        <ExternalLink className="w-4 h-4 sm:w-5 sm:h-5 text-amber-700 flex-shrink-0 group-hover:translate-x-0.5 transition-transform" />
      ) : (
        <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 text-amber-700 flex-shrink-0 group-hover:translate-x-0.5 transition-transform" />
      )}
    </>
  );

  return (
    <div className="max-w-7xl mx-auto px-4 pt-3" data-testid="smart-fridge-banner">
      {isExternal ? (
        <a href={externalUrl} target="_blank" rel="noopener noreferrer" {...commonProps}>
          {inner}
        </a>
      ) : (
        <Link to={`/loc/${slug}/fridge`} {...commonProps}>
          {inner}
        </Link>
      )}
    </div>
  );
}
